import React, { useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import engineGif from "../image/engine.gif";

const SalesReturn = ({ id, spare, fetchSalesData, show2 }) => {
	const [openModal, setOpenModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [returnQuantity, setReturnQuantity] = useState(0);
	const { globalValue } = useContext(GlobalContext);
	const [brand, setBrand] = useState("");
	const [model, setModel] = useState("");
	const [loading, setLoading] = useState(false);



	const handleOpenModal = (product) => {
		setSelectedProduct(product);
		setReturnQuantity(product.quantity);
		setBrand(product.brand);
		setModel(product.model);
		setOpenModal(true);
	};


	const handleCloseModal = () => {
		setOpenModal(false);
		setSelectedProduct(null);
	};


	const handleReturn = async (spare_id) => {
		setLoading(true);
		try {
			const response = await axios.post(
				`${globalValue}/sales_return`,
				{
					id: id,
					spare_id: spare_id,
					quantity: returnQuantity,
					brand: brand,
					model: model,
				},
				{
					headers: { "x-access-token": sessionStorage.getItem("token") },
				}
			);

			const data = response.data;

			if (data.status === "success" || data.status === "warning") {
				let alertIcon = data.status === "warning" ? "warning" : "success";
				let titleText = data.status === "warning" ? "Refund Required" : "Success";
				let messageText = data.message || "Sales return processed successfully";

				await Swal.fire({
					title: titleText,
					text: messageText,
					icon: alertIcon,
					confirmButtonText: "OK",
				});

				setOpenModal(false);
				fetchSalesData();
				show2(false);
			}
			else if (data.status === "error") {
				Swal.fire({
					title: "Error",
					text: data.message || "Failed to process sales return",
					icon: "error",
				});
			}
			else {
				Swal.fire({
					title: "Error",
					text: "Unexpected server response",
					icon: "error",
				});
			}

		} catch (error) {
			console.error("Error in handleReturn:", error);
			Swal.fire({
				title: "Error",
				text: error.response?.data?.message || "Something went wrong",
				icon: "error",
			});
		} finally {
			setLoading(false);
		}
	};




	const columns = [
		{ name: "GST", selector: (row) => row.gst, sortable: true },
		{ name: "Name", selector: (row) => row.name1, sortable: true },
		{ name: "Brand", selector: (row) => row.brand, sortable: true },
		{ name: "Model", selector: (row) => row.model, sortable: true },
		{ name: "Price", selector: (row) => row.price, sortable: true },
		{ name: "Quantity", selector: (row) => row.quantity, sortable: true },
		{ name: "Spare ID", selector: (row) => row.spareId, sortable: true },
		{
			name: "Action",
			cell: (row) =>
				row.quantity > 0 ? (
					<Button size="xs" color="blue" onClick={() => handleOpenModal(row)}>
						Return
					</Button>
				) : (
					<span style={{ color: "red" }}>No Quantity</span>
				),
		},
	];


	return (
		<div className="px-2">
			{loading && (
				<div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
					<img src={engineGif} alt="Loading..." className="w-24 h-24" />
				</div>
			)}

			<DataTable columns={columns} data={spare} pagination />


			<Modal show={openModal} onClose={handleCloseModal}>
				<Modal.Header className="flowbite-modal-h">Return Spare</Modal.Header>
				<Modal.Body className="flowbite-modal-h">
					{selectedProduct && (
						<div className="space-y-4">

							<p><strong>Name:</strong> {selectedProduct.name1}</p>


							<div>
								<Label htmlFor="quantity" value="Return Quantity" />
								<TextInput
									id="quantity"
									type="number"
									value={returnQuantity}
									onChange={(e) => setReturnQuantity(e.target.value)}
									min="1"
									max={selectedProduct.quantity}
									color="white"
								/>
							</div>
						</div>
					)}
				</Modal.Body>
				<Modal.Footer className="flowbite-modal-h">
					<Button color="gray" onClick={handleCloseModal}>
						Cancel
					</Button>
					<Button color="blue" onClick={() => { handleReturn(selectedProduct.spareId) }}>
						Confirm Return
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default SalesReturn;
